import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";

interface editProjectGoals {}

export const updateProjectGoals = async (
  org_id: any,
  org_user_id: any,
  goal_id: any,
  data: any
) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/goals/${goal_id}`;
  return await PATCH({ apiUri: path, data })
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
